module.exports = __webpack_public_path__ + "static/media/design5.76b1548b.png";